import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";

import { LocalActionsService } from './local-actions.service';
import { CallbackHelpers } from "../../shared/helpers/callback-helpers";
import { LocalAction, LocalActionButton } from "./interfaces/local-action";
import { Generic } from "../../shared/models/generic";
import { Translate } from "../../shared/helpers/translate";
import { BaseSubscriber } from "../../shared/base/base-subscriber";
import { LocalActionsWhere } from "./interfaces/local-actions-where";

@Component({
	selector: 'app-local-actions',
	templateUrl: './local-actions.component.html',
	styleUrls: ['./local-actions.component.scss']
})
export class LocalActionsComponent<T> extends BaseSubscriber implements OnInit, OnDestroy {
	@Input('where')
	set where(where: LocalActionsWhere) {
		this.where$.next(where);
	}
	get where(): LocalActionsWhere {
		return this.where$.value;
	}
	where$ = new BehaviorSubject<LocalActionsWhere>('breadcrumb');
	localActions: LocalActionButton<T>[] = [];

	constructor(
		private actionsService: LocalActionsService,
		private changeDetectorReference: ChangeDetectorRef
	) {
		super();
	}

	ngOnInit(): void {
		this.where$.pipe(
			takeUntil(this.destroyRef$),
			switchMap(where => this.actionsService.watchActions(where)),
		).subscribe(actions => {
			this.setLocalActions(actions);
			this.sendCreateAction();
			this.changeDetectorReference.detectChanges();
		});
	}

	areThereLocalActions(): boolean{
		return !!this.localActions.length;
	}

	isTabs(): boolean{
		return this.where === 'tabs';
	}

	canShowButton(action: LocalActionButton) {
		if(typeof action.condition === 'function')
			return action.condition();

		return !!action.condition;
	}

	setLocalActions(actions: LocalAction|Generic): void{
		if(actions?.localActions) this.localActions = actions.localActions;
		else this.localActions = [];
	}

	tooltip(action: LocalActionButton){
		const tooltip = CallbackHelpers.toCallback(action?.tooltip)();
		return Translate.value(tooltip);
	}

	sendCreateAction(): void{
		if(this.where !== 'breadcrumb') return;

		let indexAction = -1;

		this.localActions.forEach((action: LocalActionButton, index: number) => action.isNew ? indexAction = index : null);

		if(indexAction >= 0) this.actionsService.sendCreateAction(this.localActions.splice(indexAction, 1)[0]);
		else this.actionsService.sendCreateAction({});
	}
}
